<template>
  <v-menu bottom rounded offset-y>
    <template v-slot:activator="{ on }">
      <v-btn color="grey" elevation="0" v-on="on" icon>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list dense>
        <v-list-item v-for="item in menuItems" :key="item.icon" @click="item.action(user)">
          <v-icon class="mr-3 grey--text text--lighten-1" small left> {{ item.icon }} </v-icon>
          <span class="body-2">{{ item.text }}</span>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'RealEstateUserMenu',

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      menuItems: [
        {
          icon: 'mdi-eye-outline',
          text: this.$t('realEstateUsers.actions.show'),
          action: (user) => this.$emit('showUser', user.id),
        },
        {
          icon: 'mdi-pencil-outline',
          text: this.$t('realEstateUsers.actions.edit'),
          action: (user) => this.$emit('editUser', user.id),
        },
        {
          icon: 'mdi-delete-outline',
          text: this.$t('realEstateUsers.actions.exclude'),
          action: (user) => this.$emit('deleteUser', user.id),
        },
      ],
    }
  },
}
</script>
